import React from "react";
// Quick Access

// Default
import { useNavigate } from "react-router-dom";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";

// Svg
import User from "../../assets/svg/user";
import Navigate2 from "../../assets/svg/navigate2";
import Meter from "../../assets/svg/meter";
import ConsumptionReport from "../../assets/svg/consumptionReport";
import HealthReport from "../../assets/svg/healthReport";
import ProtectionReport from "../../assets/svg/protectionReport";

// Theme
import theme from "../../theme";

const QuickAccess: React.FC = () => {
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const navigate = useNavigate();

  const QUICK_ACCESS = [
    {
      icon: <User fill="#A5C2F0" />,
      title: "Consumer",
      spanText: "360",
      link: "/consumer-360",
      description:
        "Analysing consumer behaviour by integrating various data sources and insights.",
    },
    {
      icon: <Meter fill="#A5C2F0" />,
      title: "Meter",
      spanText: "360",
      link: "/meter-dashboard",
      description:
        "Offers real-time monitoring, analytics,automated data collection to improve the utility management .",
    },
    {
      icon: <ConsumptionReport fill="#A5C2F0" />,
      title: "Consumption",
      spanText: "Report",
      link: "/consumer-360",
      description:
        "Tracking resource usage, identifying trends, and optimising consumption to improve efficiency.",
    },
    {
      icon: <HealthReport fill="#A5C2F0" />,
      title: "Meter Health",
      spanText: "Report",
      link: "",
      description:
        "Tracking resource usage, identifying trends, and optimising consumption to improve efficiency.",
    },
    {
      icon: <ProtectionReport fill="#A5C2F0" />,
      title: "Revenue Protection",
      spanText: "Report",
      link: "",
      description:
        "Tracking resource usage, identifying trends, and optimising consumption to improve efficiency.",
    },
  ];

  return (
    <Card className="quick_access">
      <Typography
        variant="h6"
        className="dashboard_card_title"
        fontSize={"15px"}
        marginBottom={"32px"}
        fontWeight={700}
      >
        Quick Access
      </Typography>

      <Stack
        direction={"column"}
        gap={"24px"}
        height={"100%"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
      >
        {QUICK_ACCESS.map((item, index) => {
          return (
            <Stack direction="row" gap={"15px"} key={index}>
              <Box>{item.icon}</Box>
              <Box>
                <Stack direction="row" gap="4px" alignItems="center">
                  <Typography
                    variant="body1"
                    fontSize={"15px"}
                    fontWeight={700}
                    color="#000000"
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    fontWeight={500}
                    color="#000000"
                    fontSize={"15px"}
                  >
                    {item.spanText}
                  </Typography>
                  <IconButton
                    sx={{ ml: 1 }}
                    onClick={() => {
                      if (item.link) {
                        navigate(item.link);
                      }
                    }}
                  >
                    <Navigate2 />
                  </IconButton>
                </Stack>
                <Typography
                  variant="body2"
                  fontSize={"12px"}
                  color="#727272"
                  mt="4px"
                  maxWidth={matches ? "250px" : "300px"}
                >
                  {item.description}
                </Typography>
              </Box>
            </Stack>
          );
        })}
      </Stack>
    </Card>
  );
};

export default QuickAccess;
